import { Images } from 'assets/images/images.index';
import { Button } from 'components/atoms/Button/Button';
import { DetailAccordion } from 'components/atoms/Detail-accordion/Detail-accordion';
import { Input } from 'components/atoms/Input/Input';
import { TitleWhitImage } from 'components/atoms/Title-whit-image/Title-whit-image';
import { HeaderWithSteps } from 'components/organisms/Header-with-steps/Header-with-steps';
import { useFormik } from 'formik';
import { IAppReducer } from 'models';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { renewalSubscriptionService } from 'shared/services/payments';
import { stepsRenewalSubscription } from './models/renewal-subscription.constants';
import {
  IFormRenewalSubscription,
  IFormRenewalSubscriptionErrors,
} from './models/renewal-subscription.interface';
import './Renewal-subscription-page.scss';

export const RenewalSubscriptionPage = () => {
  const navigate = useNavigate();
  const [errorPayment, setErrorPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Note: Remove when renewalSubscription be correct
  const { authReducer: user } = useSelector((state: IAppReducer) => state);
  const userImpersonationId = user?.agentAuthData?.userId ?? null;

  const goToHome = () => {
    navigate('/settings/payments');
  };

  const formRenewalSubcriptionInitialValues: IFormRenewalSubscription = {
    idSubscription: '',
  };
  const formRenewalSubcriptionValidate = (values: IFormRenewalSubscription) => {
    const errors: IFormRenewalSubscriptionErrors = {};
    if (!values.idSubscription) {
      errors.idSubscription = 'Este campo es requerido';
    }
    return errors;
  };

  const renewalSubscription = async (values: IFormRenewalSubscription) => {
    await renewalSubscriptionService(
      values.idSubscription,
      userImpersonationId
    );
    // Note: Workaround - La página se recarga después de 10 segundos.
    // Esto es temporal; lo ideal es manejar correctamente la respuesta de renewalSubscriptionService
    // en el servidor para evitar depender de un reload.
    setTimeout(() => {
      goToHome();
    }, 10000);
  };

  const formRenewalSubscription = useFormik({
    initialValues: formRenewalSubcriptionInitialValues,
    validate: formRenewalSubcriptionValidate,
    onSubmit: async (values) => {
      try {
        setIsLoading(true); // Note: Remove when renewalSubscription be correct
        setErrorPayment(false);
        await renewalSubscription(values);
      } catch (error) {
        setIsLoading(false); // Note: Remove when renewalSubscription be correct
        setErrorPayment(true);
      }
    },
  });
  return (
    <>
      <HeaderWithSteps
        navbarTemplate="light"
        steps={stepsRenewalSubscription}
        onClick={goToHome}
        notProgress={true}
      />
      <div className="renewal__subscription__container">
        {errorPayment && (
          <>
            <DetailAccordion tilte="ERROR EN EL PAGO" type="error">
              Ocurrió un error al renovar la suscripción con id{' '}
              {formRenewalSubscription.values.idSubscription}
            </DetailAccordion>
          </>
        )}
        <TitleWhitImage
          title="Información <br /> de la suscripción"
          image={Images.paymentInfo}
          styleInLineImage={{ width: '2.62781rem', height: '6.25rem' }}
        ></TitleWhitImage>
        <div className="renewal__subscription__content">
          <Input
            label="Id de suscripción"
            id="id-subscription"
            type="charcode"
            name="idSubscription"
            onChange={formRenewalSubscription.handleChange}
            onBlur={formRenewalSubscription.handleBlur}
            value={formRenewalSubscription.values.idSubscription}
            isTouched={formRenewalSubscription.touched.idSubscription}
            errorInput={formRenewalSubscription.errors.idSubscription}
            errorLabel={formRenewalSubscription.errors.idSubscription}
            isRequired={true}
            form={formRenewalSubscription}
          />
          <Button
            color="primary"
            size="medium"
            template="primary"
            typeStyle="rounded"
            className="from__login__button"
            type="submit"
            onClick={formRenewalSubscription.handleSubmit}
            isDisabled={!formRenewalSubscription.isValid} // Note: Add || formRenewalSubscription.isSubmitting when renewalSubscription be correct
            isLoading={isLoading || formRenewalSubscription.isSubmitting} // Note: Remove isLoading when renewalSubscription be correct
          >
            Continuar
          </Button>
        </div>
      </div>
    </>
  );
};
